const events = [
    {
        "name": "NewParkingLotJoiningRequest",
        "id": "pfAw6fsMr6pSz4W8VKeBNy",
        "type": 8,
        "message": "6D7TgZs8ALDZtfMbkz1A6S",
        "condition": "default",
        "src": "nJbUsF7skLFtmyT29y96zs-303",
        "dst": "jQ3r5VEk1qwwKK5GUqBVBp-401",
        "attributes": {
            "onrecv": true,
            "onsend": true
        }
    },

    {
        "name": "FinalRequestConfirmation",
        "id": "pfAw6fsMr6pSz4W8VKeB12",
        "type": 8,
        "message": "6D7TgZs8ALDZtfMbkz1A6S",
        "condition": "default",
        "src": "oft3c5R8B3ebY5au9hnTz1-101",
        "dst": "jQ3r5VEk1qwwKK5GUqBVBp-401",
        "attributes": {
            "onrecv": true,
            "onsend": true
        }
    },

    {
        "name": "NewParkingLotJoiningResponse",
        "id": "pfAw6fsMr6pSz4W8VKeBUy",
        "type": 8,
        "message": "6D7TgZs8ALDZtfMbkz1A6S",
        "condition": "default",
        "dst": "nJbUsF7skLFtmyT29y96zs-303",
        "src": "jQ3r5VEk1qwwKK5GUqBVBp-401",
        "attributes": {
            "onrecv": false,
            "onsend": true
        }
    },

    {
        "name": "Transaction_Message_991",
        "id": "pfAw6fsMr6pSz4W8VKeBUAA",
        "type": 8,
        "message": "6D7TgZs8ALDZtfMbkz1A6S",
        "condition": "default",
        "dst": "nJbUsF7skLFtmyT29y96zs-303",
        "src": "jQ3r5VEk1qwwKK5GUqBVBp-401",
        "attributes": {
            "onrecv": false,
            "onsend": true
        }
    },

    {
        "name": "Transaction_Message_992",
        "id": "pfAw6fsMr6pSz4W8VKeBUAX",
        "type": 8,
        "message": "6D7TgZs8ALDZtfMbkz1A6S",
        "condition": "default",
        "src": "nJbUsF7skLFtmyT29y96zs-303",
        "dst": "jQ3r5VEk1qwwKK5GUqBVBp-401",
        "attributes": {
            "onrecv": false,
            "onsend": true
        }
    },

    {
        "name": "NewParkingLotJoiningRequestLast",
        "id": "pfAw6fsMr6pSz4W8VKeBN21",
        "type": 8,
        "message": "6D7TgZs8ALDZtfMbkz1A6S",
        "condition": "default",
        "src": "nJbUsF7skLFtmyT29y96zs-303",
        "dst": "jQ3r5VEk1qwwKK5GUqBVBp-401",
        "attributes": {
            "onrecv": true,
            "onsend": true
        }
    },
]

export default events